import { render, staticRenderFns } from "./BatchEdit.vue?vue&type=template&id=ae0018b6&scoped=true"
import script from "./BatchEdit.vue?vue&type=script&lang=js"
export * from "./BatchEdit.vue?vue&type=script&lang=js"
import style0 from "./BatchEdit.vue?vue&type=style&index=0&id=ae0018b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0018b6",
  null
  
)

export default component.exports